import { Component, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import {
  Router,
  RouteReuseStrategy,
  RouterOutlet
} from '@angular/router';
import { TitleServiceProvider } from "./common/providers/title-service-provider";
import { startWith } from "rxjs/operators";
import { NgIf } from "@angular/common";
import { CustomReuseStrategy } from "./common/strategies/custom-reuse-strategy";
import { FullScreenLoaderComponent } from "./common/components/full-screen-loader/full-screen-loader";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { ChatCounterService } from "./chat/message/chat-counter.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { interval, Subscription, switchMap, tap } from "rxjs";
import { routerTransition } from "./common/animations/router-transition";
import { CurrentUser } from "./common/providers/current-user";
import { environment } from "../environments/environment";
import { MaintenanceService } from "./common/providers/maintenance.service";

// AoT requires an exported function for factories
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, '/assets/i18n/', `.json?v=${environment.version}`);
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  standalone: true,
  imports: [
    RouterOutlet,
    NgIf,
    FullScreenLoaderComponent,
  ],
  providers: [{
      provide: RouteReuseStrategy,
      useClass: CustomReuseStrategy
  }],
  animations: [routerTransition],
})
export class AppComponent implements OnInit, OnDestroy{
  title = 'elitment-web';

  @ViewChild('discussionRef', { static: false, read: ViewContainerRef })
  public discussionRefs: ViewContainerRef | null = null;

  private chatCounterSubscription: Subscription | null = null;


  private _lastPoppedUrl: string | null = null;
  private _yScrollStack: number[] = [];

  constructor(
    private router: Router,
    private titleServiceProvider: TitleServiceProvider,
    private chatCounterService: ChatCounterService,
    private maintenanceService: MaintenanceService,

    // to debug user navigation uncomment the 2 lines below
    // private appRouteChangeService: AppRouteChangeService,

    // private updates: SwUpdate,
    private snackBar: MatSnackBar,
    private currentUser: CurrentUser,
  ) {
    // updates.available.subscribe(event => {
    //   updates.activateUpdate().then(() => this.updateApp());
    // });
  }

  ngOnInit(): void {
    this.titleServiceProvider.boot();
    // this.updateChatCounterService(); // TODO : FIX UNDEFINITE LOADING OF PAGE

    this.showMaintenanceDialog();

    // this.fixScrollNavigationIssue();
    // permet de corriger le problème lorsqu'on navigue et que la nouvelle route
    // charge le même composant (la page n'est pas reloadée ...)
    // inspiré de : https://stackoverflow.com/a/45737269
  }

  private showMaintenanceDialog(): void {
    if (environment.maintenance.enabled) {
      this.maintenanceService.showMaintenanceDialog(
        environment.maintenance.titleKey,
        environment.maintenance.messageKey,
        environment.maintenance.storageKey
      );
    }
  }


  ngOnDestroy(): void {
    if (this.chatCounterSubscription) {
      this.chatCounterSubscription.unsubscribe();
    }
  }

  updateChatCounterService(): void {
    this.chatCounterSubscription = interval(30000).pipe(
      startWith(0),
      switchMap(() => this.chatCounterService.refreshChatCounter())  // refreshChatCounter must return ObservableInput<any>
    ).subscribe();
  }

  public getTransition(): string {
    // TODO pour pas calculer la transition toutes les 2ms,
    // peut �tre utiliser une variable qui se met � jour
    // quand on d�tecte un navigationStart/navigationEnd
    return 'todo';
  }

  public getChatDiscussionRef() {
    return this.discussionRefs;
  }


  // private fixScrollNavigationIssue(): void {
  //   // r�soud le probl�me de la position du scroll quand on navigue d'une page � une autre.
  //   // (si sur une page on click sur un lien qui se trouve plus bas que la hauteur view port
  //   // et que le lien pointe vers une page plus grande que la hauteur du viewport
  //   // on arrive le scroll est conserv� ...)
  //   // doc : https://stackoverflow.com/questions/39601026/angular-2-scroll-to-top-on-route-change
  //   this._location.subscribe((ev: PopStateEvent) => {
  //     this._lastPoppedUrl = ev.url;
  //   });
  //   this._router.events.subscribe((ev: any) => {
  //     if (ev instanceof NavigationStart) {
  //       if (ev.url != this._lastPoppedUrl) {
  //         this._yScrollStack.push(window.scrollY);
  //       }
  //     } else if (ev instanceof NavigationEnd) {
  //       if (ev.url == this._lastPoppedUrl) {
  //         this._lastPoppedUrl = undefined;
  //         window.scrollTo(0, this._yScrollStack.pop());
  //       } else {
  //         window.scrollTo(0, 0);
  //       }
  //     }
  //   });
  // }

  // private updateApp(): void {
  //   this.snackBar.open('New version available. Updating...', '', {
  //     duration: 2000,
  //   });
  //
  //   setTimeout(() => {
  //     document.location.reload();
  //   }, 2300);
  // }

}
